const privateLDAttributeNames = ['email']
const getLDUser = function(userEmail, userID, extraUserData) {
  return {
    key: userID,
    email: userEmail,
    custom: {
      type: 'APPAISER_USER',
      company_id: extraUserData.companyID,
    },
    privateLDAttributeNames,
  }
}

export { getLDUser, privateLDAttributeNames }
